import { useCallback } from 'react';

type AppleUser = {
  name?: {
    firstName: string;
    lastName: string;
  };
  email: string;
};

type AppleLoginResult = {
  socialMediaId: string;
  firstname?: string;
  lastname?: string;
  email: string;
  type: 'apple';
};

type UseAppleLoginProps = {
  onLogin: (_data: AppleLoginResult) => void;
  formState: any;
};

export const useAppleLogin = ({ onLogin, formState }: UseAppleLoginProps) => {
  const handleAppleLogin = useCallback(
    (socialMediaId: string, user: AppleUser) => {
      const formFieldValues = {
        ...formState,
        socialMediaId,
        firstname: user?.name?.firstName,
        lastname: user?.name?.lastName,
        email: user?.email,
        type: 'apple' as const,
      };
      onLogin(formFieldValues);
    },
    [formState, onLogin],
  );

  return {
    handleAppleLogin,
  };
};
